export const GET_ALL_HOME_PAGE_DATA= "GET_ALL_HOME_PAGE_DATA";
